
import { Component, Prop, Vue } from 'vue-property-decorator'
import { useUserStore } from '@/stores/user'
import { useDeveloperModeStore } from '@/stores/developerMode'

@Component({
  name: 'SidebarLogo'
})
export default class extends Vue {
  @Prop({ required: true }) private collapse!: boolean

  userStore: any = useUserStore()
  developerModeStore = useDeveloperModeStore()

  get title() {
    return this.userStore.model.manageable.name
  }

  get userLogo() {
    return this.userStore.model.manageable.logo
  }

  get roles() {
    return this.userStore.roles
  }

  onLogoAreaClick(): void {
    const toggled = this.developerModeStore.registerLogoClick()
    if (!toggled) return

    if (this.developerModeStore.enabled) {
      this.$notify({
        title: this.$t('developerMode.enabledTitle') as string,
        message: this.$t('developerMode.enabledMessage') as string,
        type: 'success',
        duration: 3000
      })
    } else {
      this.$notify({
        title: this.$t('developerMode.disabledTitle') as string,
        message: this.$t('developerMode.disabledMessage') as string,
        type: 'info',
        duration: 3000
      })
      if (this.$route.matched.some(record => record.meta?.developerOnly)) {
        this.$router.push('/')
      }
    }
  }
}
